import React from "react";
import { HomeOutlined } from "@ant-design/icons";
import { HomePhoneProduct } from "../../../../../types/homePhone";

interface ProductImageProps {
  product: HomePhoneProduct;
}

const ProductImage: React.FC<ProductImageProps> = ({ product }) => (
  <span className="home-phone-product-image">
    {product.imageUrl ? (
      <img src={product.imageUrl} alt={product.name} />
    ) : (
      <HomeOutlined aria-hidden="true" />
    )}
  </span>
);

export default ProductImage;
